import React, { useState, useContext, useEffect } from 'react';
import Head from 'next/head';
import Link from 'next/link';
import { useRouter } from 'next/router';
import Form from '@components/Shared/Form/Form';
import { buildQueryString } from 'pubweb-smokey/dist/utils/utils';
import { runCommonValidation } from 'pubweb-smokey/dist/utils/validation';
import Button from '@components/Shared/Buttons/Button';
import LandItSplashStyles from './LandItSplash.styled.js';
import LocationTextBox from '@components/Shared/LocationSelector/LocationTextBox';
import { LocationsContext } from '@contexts/LocationsContext';
import { getSiteUrl } from '@utils/config';

const LandItSplash = () => {
  const locationsContext = useContext(LocationsContext);

  const [formErrors, setFormErrors] = useState({});
  const [postalCode, setPostalCode] = useState(
    locationsContext.state.postalCode
  );

  const router = useRouter();

  const onPostalCodeChange = (value) => {
    setPostalCode(value);
  };

  const search = (zip) => {
    let checkErrors = validate(zip || postalCode);

    setFormErrors(checkErrors);

    if (!checkErrors.hasErrors) {
      const buildQueryParameters = () => {
        const queryBuilder = {
          zip: zip || postalCode,
          radius: 5,
          minPrice: '0',
          maxPrice: '40000',
          page: 1,
          sortBy: '0',
        };

        return queryBuilder;
      };

      router.push({
        pathname: '/find-land/listings/',
        search: buildQueryString(buildQueryParameters()),
      });
    }
  };

  const onLocationSelect = () => {
    search();
  };

  const validate = (zip) => {
    return runCommonValidation({ zip: { touched: true, value: zip || '' } });
  };

  useEffect(() => {
    setPostalCode(locationsContext.state.postalCode);
  }, [locationsContext.state.postalCode]);

  return (
    <LandItSplashStyles>
      <Head htmlAttributes={{ lang: 'en' }}>
        <title>Find Land | Clayton</title>
        <meta
          name="description"
          content="Looking for a place to put your dream home? Find land for sale near you and search property listings in your area."
        />
        <link rel="canonical" href={`${getSiteUrl(router.pathname)}`} />
        <meta
          property="og:image"
          content={getSiteUrl('/public-assets/images/california-hills.jpg')}
        />
        <meta
          name="twitter:image"
          content={getSiteUrl('/public-assets/images/california-hills.jpg')}
        />
        <meta
          property="og:description"
          content="Looking for a place to put your dream home? Find land for sale near you and search property listings in your area."
        />
        <meta property="og:type" content="website" />
      </Head>
      <div className="splash-container">
        <div className="search-container">
          <h1>Find Land for Sale</h1>
          <p>Find the perfect property for your dream home.</p>
          <div className="search-box">
            <div className="search-bar">
              {formErrors.zip ? (
                <p className="error-msg">Please enter a city, state or zip.</p>
              ) : (
                ''
              )}
              <Form onSubmit={(formData) => search(formData.zip)}>
                <div className="search-field-group">
                  <LocationTextBox
                    locationKey="landIt"
                    postalCode={postalCode}
                    // formErrors={formErrors}
                    onPostalCodeChange={onPostalCodeChange}
                    finishSelection={onLocationSelect}
                  />
                  <Button className="find-land-search search-button">
                    SEARCH
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <div className="terms-link">
          <Link href="/find-land/terms-of-use">ListHub Data Terms of Use</Link>
        </div>
      </div>
    </LandItSplashStyles>
  );
};

export default LandItSplash;
